<template>
    <v-container>
        <v-row>
          <v-col cols="4">
            <v-combobox
              v-model="selected_kols"
              :items="accessableKols"
              label="筛选达人"
              multiple
              chips
            ></v-combobox>
          </v-col>
          <v-col cols="4">
            <v-text-field
              label="搜索视频"
              v-model="search"
              single-line
              hide-details
              @keyup.enter="triggerSearch"
            ></v-text-field>
          </v-col>
          <v-col cols="1" class="text-left">
            <v-btn icon @click="triggerSearch" :disabled="loading">
              <v-icon>mdi-magnify</v-icon>
            </v-btn>
          </v-col>
        </v-row>
        
        <v-row v-if="loading">
          <v-col cols="12">
            <v-text-field>加载中...</v-text-field>
            <v-progress-linear indeterminate color="primary"></v-progress-linear>
          </v-col>
        </v-row>

        <v-expansion-panels v-if="!loading">
            <VideoResult :videos="videos" />
        </v-expansion-panels>

    </v-container>
</template>
  
<script setup>
import { ref, watch,onMounted, watchEffect,computed,defineEmits  } from 'vue'
import axios from 'axios'
import store from '@/store';
import {BASE_URL} from '@/config.js'
import {useRouter} from 'vue-router'

import VideoResult from '@/components/result_show/VideoSearchResult.vue'

// import {useStore} from 'vuex'
// const store = useStore()
  
  // 获取视频列表
  const videos = ref([])   
  const selected_kols = ref(null)

  // 搜索框绑定的响应式变量
  const router = useRouter()  
  // const search = computed(() => {
  //   const query = router.currentRoute.value.query
  //   return query.search ? query.search : null
  // })
  const search = ref(router.currentRoute.value.query.search || null)
  const talentParam = ref(router.currentRoute.value.query.talent ? router.currentRoute.value.query.talent.split(',') : null)  // 从url中获取的talent参数



  // axios.get(BASE_URL+'get_video_material_list/')
  // .then(response => {
  //   videos.value = response.data
  // })

  // axios.get(BASE_URL+'get_video_material_list/')
  //   .then(response => {
  //     videos.value = response.data
  //     // 排序，根据shooting_time字段，从小到大排序
  //     // videos.value.sort((a, b) => a.shooting_time - b.shooting_time)
  //     // console.log('videos.value', videos.value[0])
  //   })

  const accessableKols = ref([])
  axios.get(BASE_URL+'get_accessable_kol_list/')
    .then(response => {
      // 转换response.data到combobox需要的格式
      const kolMap = new Map();
      response.forEach(kol => {
        const kolItem = {
          value: kol.id,
          title: kol.name
        };
        accessableKols.value.push(kolItem);
        kolMap.set(kol.id, kolItem);
      });
      
      // 根据talentParam初始化selected_kols
      if (talentParam.value && talentParam.value.length) {
        selected_kols.value = talentParam.value
          .map(talentId => kolMap.get(talentId))
          .filter(kolItem => kolItem != null); // 过滤掉未找到的项
      }else{
        sessionStorage.getItem('selectedKols') ? selected_kols.value = JSON.parse(sessionStorage.getItem('selectedKols')) : null
      }

      triggerSearch();
    })

     



  // 从url中读取传入的参数
  // onMounted(() => {
  // console.log('router.currentRoute.value', router.currentRoute.value)
  // const query = router.currentRoute.value.query
  // if (query.search){
  //   search.value = query.search
  // }    
  // })

  const emit = defineEmits(['videoSelected'])

  const loading = ref(false)

  const highlightKeyword = (text, keyword) => {
    // if (keyword) {
    //   const reg = new RegExp(keyword, 'gi')
    //   return text.replace(reg, '<span style="color: red;">' + keyword + '</span>')
    // } else {
    //   return text
    // }
    if (!text || !keyword) {
        return '';
      }
      const escapedKeyword = keyword.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
      const regex = new RegExp(escapedKeyword, 'gi');
      return text.replace(regex, (match) => `<mark>${match}</mark>`);
  }

  const triggerSearch = () => {
    if (loading.value) {
      return; // 如果正在加载，就不要再触发了
    }
    loading.value = true; // Set loading to true

    console.log('selected_kols.value', selected_kols.value)
    var kol_list = selected_kols.value ? selected_kols.value.map(kol => kol.value) : [];

    if (kol_list.length === 0) {
      kol_list = null;
    }

    if (kol_list) {
      kol_list = kol_list.join(',');
    }

    sessionStorage.setItem('selectedKols', JSON.stringify(selected_kols.value))

    axios
      .get(BASE_URL + 'get_video_material_list/', {
        params: {
          kol_list: kol_list,
          key_word: search.value,
        },
      })
      .then(response => {
        videos.value = response;
      })
      .finally(() => {
        loading.value = false; // Set loading to false
      });
  };

  
 
  


  // 点选事件，修改store中的currentVideo；告诉父组件，已经选择了视频，可以切换到下一个组件了
  const selectVideo = (video) => {
    //从store中获取当前视频
    // const currentVideo = store.state.currentVideo
    // if(currentVideo===video){
    //   // do nothing
    // }else{
    //   store.commit('setSelectedVideo', video)
    //   store.commit('setSelectedTextSpan', [])
    // }
    // store.commit('setSearchKeywords', search.value)      
    console.log('video', video)
    store.commit('setCurrentVideo', video)
    store.commit('setCurrentTextSpan', [])
    sessionStorage.setItem('currentVideo', JSON.stringify(video))
    sessionStorage.setItem('currentTextSpan', JSON.stringify([]))
    
    
    router.push('para')

  }
  </script>
  